import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mapTo, startWith, switchMap } from 'rxjs/operators';
import { AbstractProblemApiService } from 'src/app/core/services/abstract/abstract-problem-api-service';
import * as actions from './actions';

@Injectable()
export class ProblemStoreEffects {
  private problemApiService = inject(AbstractProblemApiService);
  private actions$ = inject(Actions);

  loadRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.LoadRequestAction>(actions.ActionTypes.LOAD_REQUEST),
      //startWith(new actions.LoadRequestAction()),
      switchMap(action =>
        this.problemApiService.getProblems().pipe(
          map(items => (items.isSucceeded ? new actions.LoadSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  saveRequesEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SaveRequestAction>(actions.ActionTypes.SAVE_REQUEST),
      switchMap(action =>
        this.problemApiService.saveProblem(action.problem).pipe(
          map(items => (items.isSucceeded ? new actions.SaveSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  createRequesEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.CreateRequestAction>(actions.ActionTypes.CREATE_REQUEST),
      switchMap(action =>
        this.problemApiService.createProblem(action.problem).pipe(
          map(items => (items.isSucceeded ? new actions.CreateSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  deleteRequesEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.DeleteRequestAction>(actions.ActionTypes.DELETE_REQUEST),
      switchMap(action =>
        this.problemApiService.deleteProblem(action.id).pipe(
          map(items => (items.isSucceeded ? new actions.DeleteSuccessAction(action.id) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  setSelectedRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SetSelectedRequestAction>(actions.ActionTypes.SET_SELECTED_REQUEST),
      switchMap(action =>
        this.problemApiService.getProblemById(action.id).pipe(
          map(items =>
            items.isSucceeded ? new actions.SetSelectedSuccessAction(items.result) : new actions.FailureAction(items.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  solvedRequesEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SolvedRequestAction>(actions.ActionTypes.SOLVED_REQUEST),
      switchMap(action =>
        this.problemApiService.solvedProblem(action.id).pipe(
          map(items => (items.isSucceeded ? new actions.SolvedSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );
}
